import { WorkspaceChannelPlatform } from "@/api/__generated__/models";

export function getSnsLabel(platform?: WorkspaceChannelPlatform) {
  if (platform == null) {
    return "";
  }

  switch (platform) {
    case WorkspaceChannelPlatform.TIKTOK:
      return "TikTok";
    case WorkspaceChannelPlatform.YOUTUBE_SHORTS:
      return "YouTube Shorts";

    case WorkspaceChannelPlatform.INSTAGRAM:
      return "Instagram";
  }
}
